#import "../fragments/landing-page-html-fragment.graphql"

mutation PreviewPage($input: PagePreviewInput!) {
    pagePreview(input: $input) {
        page {
            ...LandingPageHtmlFragment
        }
    }
}
